// app/AppContext.tsx — provides services (auth, api, config) to the tree.
import { createContext, useContext, type ReactNode } from 'react';
import type { AppServices } from './services';

const AppContext = createContext<AppServices | null>(null);

export function AppProvider({
  services,
  children,
}: {
  services: AppServices;
  children: ReactNode;
}) {
  return <AppContext.Provider value={services}>{children}</AppContext.Provider>;
}

export function useServices(): AppServices {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error('useServices must be used within <AppProvider>');
  return ctx;
}
